import indexActions from "./indexStore/actions";
// 公有内容直接写入。
var actions = {
    ...indexActions
};
export default actions;